// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b3982f8e","498":"5df1f742"}[chunkId] + ".chunk.js";
};